(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/gift-form.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/gift-form.js');
"use strict";


const {
  Form
} = svs.ui.reactForm;
const {
  Cart
} = svs.tickets_giftshop.gift.giftform.cart;
const {
  PersonalInfo,
  ReceiverTypeInfo
} = svs.tickets_giftshop.gift.giftform.components;
const {
  DateSelector
} = svs.tickets_giftshop.gift.giftform.date_selector;
const {
  PHONE,
  EMAIL,
  NAME,
  DATE,
  TIME,
  GREETING
} = svs.tickets_giftshop.constants.names;
const {
  SMOOTH,
  CENTER
} = svs.tickets_giftshop.constants.scrollIntoView;
const {
  PREVIEW_ROUTE
} = svs.tickets_giftshop.constants.routes;
const {
  inputChangeAction,
  receiverTypeChangeAction
} = svs.tickets_giftshop.gift.giftform.actions;
const {
  setErrorAction
} = svs.tickets_giftshop.gift.giftform.cart.actions;
const {
  Reminder
} = svs.tur;
const GiftForm = _ref => {
  let {
    formData = {},
    history,
    onInputChange,
    onReceiverTypeChange,
    itemsInCartCount,
    onCartError
  } = _ref;
  const cartRef = React.useRef();
  const personalRef = React.useRef();
  const receiverTypeRef = React.useRef();
  const dateRef = React.useRef();
  const ref = React.useRef();
  const isMobile = svs.core.detect.formfactor.mobile();
  const scrollOffsetY = React.useMemo(() => {
    var _getComputedStyle, _getComputedStyle2;
    const fixedTopContentHeight = parseInt((_getComputedStyle = getComputedStyle(document.documentElement)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.getPropertyValue('--fixedTopContentHeight'), 10) || 0;
    const itemsMenuWrapperHeight = (isMobile ? 0 : parseInt((_getComputedStyle2 = getComputedStyle(document.documentElement)) === null || _getComputedStyle2 === void 0 ? void 0 : _getComputedStyle2.getPropertyValue('--itemsMenuWrapperHeight'), 10)) || 0;
    return fixedTopContentHeight - itemsMenuWrapperHeight;
  }, [isMobile]);
  const handlePreviewSubmit = (e, formData) => {
    e && e.preventDefault();
    const ops = {
      behavior: SMOOTH,
      block: CENTER
    };
    if (!itemsInCartCount) {
      onCartError && onCartError();
      cartRef.current.scrollIntoView(ops);
    } else if (!formData[NAME].isValid || !formData[GREETING].isValid) {
      personalRef.current.scrollIntoView(ops);
    } else if (formData[EMAIL] && !formData[EMAIL].isValid || formData[PHONE] && !formData[PHONE].isValid) {
      receiverTypeRef.current.scrollIntoView(ops);
    } else if (!formData[DATE].isValid || !formData[TIME].isValid) {
      receiverTypeRef.current.scrollIntoView(ops);
    } else {
      history && history.push(PREVIEW_ROUTE);
    }
  };
  const handleInputChange = _ref2 => {
    let {
      target: {
        value,
        name
      }
    } = _ref2;
    onInputChange && onInputChange({
      field: name,
      value
    });
  };
  const handleReceiverTypeChange = value => {
    onReceiverTypeChange && onReceiverTypeChange({
      value
    });
  };
  return React.createElement("div", {
    className: "tg-forms-container",
    ref: ref
  }, React.createElement(Reminder, {
    ref: ref,
    scrollConfig: {
      yOffset: scrollOffsetY
    }
  }), React.createElement(Form, {
    className: "tg-forms relative col-xs-12 col-sm-10 col-md-8 col-lg-6",
    id: "tg-gift-form",
    onSubmit: handlePreviewSubmit
  }, React.createElement(PersonalInfo, {
    greeting: formData.greeting,
    name: formData.name,
    onInputChange: handleInputChange,
    personalGreeting: formData.personalGreeting,
    ref: personalRef
  }), React.createElement(ReceiverTypeInfo, {
    email: formData.email,
    onInputChange: handleInputChange,
    onReceiverTypeChange: handleReceiverTypeChange,
    phone: formData.phone,
    receiverType: formData.receiverType,
    ref: receiverTypeRef
  }), React.createElement(DateSelector, {
    date: formData.date,
    dateSelector: formData.dateSelector,
    nameDayName: formData.nameDayName,
    onInputChange: handleInputChange,
    ref: dateRef,
    time: formData.time
  }), React.createElement("input", {
    className: "hide",
    type: "submit"
  }), React.createElement(Cart, {
    ref: cartRef
  })));
};
const mapState = state => {
  const {
    settings,
    cart
  } = state;
  const targetCartState = cart[settings.branding] || {};
  return {
    formData: state.giftform,
    itemsInCartCount: targetCartState.count
  };
};
const mapDispatch = dispatch => ({
  onInputChange: _ref3 => {
    let {
      field,
      value
    } = _ref3;
    return dispatch(inputChangeAction({
      field,
      value
    }));
  },
  onReceiverTypeChange: _ref4 => {
    let {
      value
    } = _ref4;
    return dispatch(receiverTypeChangeAction({
      value
    }));
  },
  onCartError: () => dispatch(setErrorAction())
});
svs.tickets_giftshop.gift.giftform.GiftForm = ReactRedux.connect(mapState, mapDispatch)(GiftForm);

 })(window);